import React from 'react';
import styles from '../asset/scoreStatisticBoard.module.scss';
import WarningIcon from './WarningIcon';
import ProgressBar from './ProgressBar';
import Milestone from './Milestone';
import CurrentMilestone from './CurrentMilestone';

const ScoreSection = ({ title, subtitle, currentScore = 700, maxScore = 800, attempted_s = 0, needsMorePractice = false, practicesLeft = 0, isFirst = false }) => {
    const calculateMilestonePosition = (score) => {
        const percentage = (score / maxScore) * 100;
        // Position relative to the progress bar container (57px offset for labels)
        return `calc(57px + (100% - 82px) * ${percentage / 100})`;
    };

    const calculateCurrentPosition = (score) => {
        if (typeof score !== 'number') return '57px'; // Default position for "--"
        const percentage = (score / maxScore) * 100;
        // Align with the end of the progress fill
        return `calc(57px + (100% - 82px) * ${percentage / 100})`;
    };

    const displayScore = typeof currentScore === 'string' ? currentScore : currentScore;
    const showMilestones = typeof currentScore === 'number';

    return (
        <div className={isFirst ? styles.sectionTop : styles.sectionBottom}>
            <div className={styles.sectionHeader}>
                <div className={styles.titleGroup}>
                    <h3 className={styles.sectionTitle}>{title}</h3>
                    {subtitle && <p className={styles.sectionSubtitle}>{subtitle}</p>}
                </div>
                <div className={styles.updateInfo}>
                    <WarningIcon />
                    <span className={styles.updateText}>Update daily</span>
                </div>
            </div>

            <div className={styles.scoreVisualization}>
                <ProgressBar current={currentScore} max={maxScore} />
                {showMilestones && (
                    <>
                        <Milestone score="30%" label="Start" position={calculateMilestonePosition(30)} />
                        <Milestone score="60%" label="1 month" position={calculateMilestonePosition(60)} />
                        <CurrentMilestone score={displayScore + '%'} position={calculateCurrentPosition(currentScore)} />
                    </>
                )}
            </div>

            <div className={styles.questionsPracticed}>
                <span>Questions practiced: {attempted_s}</span>
                {needsMorePractice && practicesLeft > 0 && (
                    <span className={styles.needsPractice}> - Need {practicesLeft} more practice{practicesLeft > 1 ? 's' : ''}</span>
                )}
            </div>
        </div>
    );
};

export default ScoreSection;
